import { Firestore } from "../lib/firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sortArrayPipe } from "shared/pipes";

toast.configure({
  autoClose: 2000,
  draggable: false
});

const CATEGORIES_TABLE_NAME = "productCategories";

export function getCategories() {
  return Firestore.collection(CATEGORIES_TABLE_NAME)
    // .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((size) => size.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getCategoriesById(id) {
  try {
    return Firestore.collection(CATEGORIES_TABLE_NAME)
    .doc(id)
    .get()
    .then((docRef) => { return docRef.data() })
      .catch((error) => { 
        throw new Error(error);
    })
  
} catch (error) {
  throw error;
}
}

export function deleteCategoriesById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(CATEGORIES_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Category deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const create = async (payload,setData,inputText,setInputText,id,setIsLoading,isLoading) => {
  try {
  // Check if already loading or if an error has occurred
  if (isLoading) {
    return;
  }
    setIsLoading(true);
    
    const loadingFunc = () => {
      setIsLoading(false)
    }
      // Check if the garment value already exists in Firestore
      const existingDoc = await Firestore.collection(CATEGORIES_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();
      
    if (!existingDoc.empty) {
      toast.error("Category already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      setTimeout(loadingFunc, 2000);

    
      return;
    }

      await Firestore.collection(CATEGORIES_TABLE_NAME).doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        toast.success("Category created successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
        setTimeout(loadingFunc, 2000);

    })
    
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload,history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(CATEGORIES_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Category already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(CATEGORIES_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Category updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
  


// import { Firestore } from "../lib/firebase";

// const CATEGORIES_TABLE_NAME = "productCategories";

// export function getCategories() {
//   return Firestore.collection(CATEGORIES_TABLE_NAME)
//     // .where("market", "==", country)
//     .get()
//     .then((results) => results.docs.map((category) => category.data()))
//     .catch((error) => {
//       throw new Error(error);
//     });
// }

// const CATEGORIES = [
//     { value: "Blazers & Jackets", label: "Blazers & Jackets", code: "BO" },
//     { value: "Dresses & Jumpsuits", label: "Dresses & Jumpsuits", code: "DJ" },
//     { value: "Jumpers & Knitwear", label: "Jumpers & Knitwear", code: "JK" },
//     {
//         value: "Tops, Shirts & Blouses",
//         label: "Tops, Shirts & Blouses",
//         code: "SBT",
//     },
//     { value: "Trousers & Shorts", label: "Trousers & Shorts", code: "TS" },
//     { value: "Skirts", label: "Skirts", code: "S" },
//     { value: "Accessories", label: "Accessories", code: "A" },
// ];



// /**
//  * Return an array of objects
//  */
// // export function getCategories() {
// //     return CATEGORIES;
// // }

async function dataStream(callback) {
  const category = await getCategories();
  callback(sortArrayPipe.transform(category, 'value'));
}



export async function getCategoryByValue(categoryValue)  {
  if (dataStream) {
    await dataStream((values) => {
      return values.find((category) => category.value === categoryValue);
    });
  }
  
}


